module.exports = __webpack_public_path__ + "static/media/tutorial-step-1.17507a44.png";